(function() { window.GUID_c12d3d33_5f5f_4d1f_bcee_cc6ce46b63e9 = { getGuid: function() { return "c12d3d33-5f5f-4d1f-bcee-cc6ce46b63e9"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: 'body',
                        childSelector: '.accordion-followers',
                        callback: function (control, e) {
                            control.$Container.offon('click.remove-follower', '.remove-follower', function () {
                                let pid = $(this).data('followerid');
                                let data = {
                                    followerid: pid
                                };
                                CS.Ajax.Post(CS.Url.CSUrl("friendblockfollower"), data, (response) => {
                                    control.RefreshContent();
                                });
                            });
                            control.$Container.offon('click.unblock-follower', '.unblock-follower', function () {
                                let pid = $(this).data('followerid');
                                let data = {
                                    followerid: pid
                                };
                                CS.Ajax.Post(CS.Url.CSUrl("friendunblockfollower"), data, (response) => {
                                    control.RefreshContent();
                                });
                            });
                        }
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=followers.js.map
